import { IngredientsInterface, RecipeE3MetaDataQL, RecipeMetaDataQueryInterface } from "../../app/homepage/homepage.types";
import { allergenFilter, dietFilter } from "../../app/homepage/homepage.utils";
import { SearchFilteredRecipesInterface } from "../../app/search/search.types";
import { recipeMetaDataTransformerFS2QL } from "../../utils/RecipeBackEnd/hasuraFSMigrationTransformers";
import { UrlFilters } from "../useFilterRecipe.types";

export const filtersFromQuery = (query: URLSearchParams): UrlFilters => {
  const filters: UrlFilters = {};

  query.forEach((value: string, key: string) => {
    if (key !== 'title' && key !== 'source') {
      if (!(key in filters)) filters[key] = [];
      filters[key].push(value);
    }
  });

  return filters;
};

export const andVariableGenerator = (filters: UrlFilters) => {
  const andArray = [];
  const {
    cuisine,
    diet,
    meal_type,
    created_by,
    cooking_time,
    Category_ID,
    recipe_category,
    serving_size
  } = filters;

  if (cuisine) andArray.push({ cuisine: { _contains: cuisine, _neq: [] } });
  if (diet) andArray.push({ diet: { _contains: diet, _neq: [] } });
  if (meal_type) andArray.push({ meal_type: { _contains: meal_type, _neq: [] } });
  if (created_by) andArray.push({ created_by: { _eq: created_by[0] }, created_source: { _eq: "userCreated" } });
  if (cooking_time) andArray.push({ Recipe_Variations: { cooking_time: { _eq: Number(cooking_time[0]) } } });
  if (Category_ID) andArray.push({ Recipe_Categories_Map: { Category_ID: { _eq: Number(Category_ID[0]) } } });
  if (recipe_category) andArray.push({ Recipe_Categories_Map: { recipe_category: { name: { _eq: recipe_category[0] } } } });
  if (!created_by) andArray.push({ is_public: { _eq: "true" } });
  if (serving_size) {
    andArray.push({
      Recipe_Variations: {
        _and: [
          { max_serving: { _gte: serving_size[0] } },
          { min_serving: { _lte: serving_size[0] } }
        ]
      }
    });
  }
  andArray.push({ is_deleted: { _eq: "false" } });

  return andArray;
};

export const transformedRecipes = (recipes: RecipeE3MetaDataQL[], ingredients: IngredientsInterface) => {
  if (recipes?.length > 0 && ingredients) return recipeMetaDataTransformerFS2QL(recipes, ingredients);
  return [];
}

export const preferencesFilteredRecipes = (recipes: SearchFilteredRecipesInterface[], userDiet: string, userAllergens: string[]) => (recipes.filter((recipe: SearchFilteredRecipesInterface) => {
  const recipeDiet = recipe.metadata.categories;
  const recipeAllergens = recipe.allergens;
  const dietMatch = dietFilter(userDiet, recipeDiet);
  const allergenMatch = allergenFilter(userAllergens, recipeAllergens);
  if (!dietMatch) return false;
  if (allergenMatch) return false;
  return true;
}))

const getMostRecentDate = (recipe: SearchFilteredRecipesInterface) =>
  new Date(
    Math.max(
      new Date(recipe.metadata.updatedAt).getTime(),
      new Date(recipe.metadata.lastEditedAt).getTime()
    )
  );

export const sanitizeHomepageRecipes = (recipes: SearchFilteredRecipesInterface[], userDiet: string, userAllergens: string[]) => preferencesFilteredRecipes(recipes, userDiet, userAllergens);

export const sanitizeListView = (
  data: RecipeMetaDataQueryInterface,
  ingredients: IngredientsInterface,
  userDiet: string,
  userAllergens: string[],
  userId: string | null,
  filters: UrlFilters
) => {
  const recipes = data.Recipes_E3;
  const transRecipes = transformedRecipes(recipes, ingredients);

  if (filters?.created_by && filters?.created_by[0] === userId) {
    if (Array.isArray(transRecipes)) {
      transRecipes.sort((olderRecipe, newerRecipe) => {
        const olderRecipeDate = getMostRecentDate(olderRecipe);
        const newerRecipeDate = getMostRecentDate(newerRecipe);

        return newerRecipeDate.getTime() - olderRecipeDate.getTime();
      });
    }
    return transRecipes;
  }
  if (Array.isArray(filters?.Category_ID) && filters?.Category_ID.length > 0) {
    const categoryMapRecipes = transRecipes.map((recipe: any) => ({
      ...recipe,
      metadata: {
        ...recipe?.metadata, mapRank: recipe?.metadata?.categoryData?.find((cat: any) => cat.Category_ID === Number(filters?.Category_ID[0]))?.mapRank,
      },
    }))
    categoryMapRecipes.sort((prev: any, next: any) => prev.metadata.mapRank - next.metadata.mapRank);
    return preferencesFilteredRecipes(categoryMapRecipes, userDiet, userAllergens)

  }
  return preferencesFilteredRecipes(transRecipes, userDiet, userAllergens);
}

export const generateHeading = (query: URLSearchParams) => {
  const categoryHeader = query.get('title');
  return categoryHeader;
};
